<template>
    <div class="flash_messages text-center">
        <flash-message v-for="(message,type) in messages" :key="message" :message="message" :type="type"></flash-message>
    </div>
</template>

<script>
export default {
    props: {
        messages: {}
    }
}
</script>